/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

const ComponentTimelineContext = createContext(null);

export { ComponentTimelineContext };
